import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/profile/device/$id/$')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/devices/$id',
      params: {
        id: params.id
      },
      replace: true
    });
  }
});